import { eccoClubBadgeGradient } from "@ecco/ui/tokens/colors";

export const badgeStyles = {
    fontSize: ["mobileBodyTextTiny", "mobileBodyTextSmall", "desktopBodyTextSmall"],
    height: "auto",
    textAlign: "start",
    fontWeight: "semibold",
    lineHeight: ["4", "5"],
    borderWidth: ["0.2"],
    borderStyle: "solid",
    paddingX: [1.2, 2],
    paddingY: [0.6, 1],
};

export const compactOnDesktopBadgeStyles = {
    fontSize: [
        "mobileBodyTextTiny",
        "mobileBodyTextSmall",
        "desktopBodyTextSmall",
        "desktopBodyTextTiny",
    ],
    lineHeight: ["4", "5", "5", "4"],
    paddingX: [1.2, 2, 2, 1],
    paddingY: [0.6, 1, 1, 0.4],
};

export const compactOnDesktopBadgesContainerStyles = {
    top: [3, 4, 4, 2],
    left: [3, 4, 4, 2],
    right: [10, 10, 10, 8],
    gap: ["0.2", "0.2", "0.2", "0.4"],
};

export const defaultBadgeStyles = {
    bg: "gray.150",
    color: "black",
    borderColor: "gray.150",
};

export const discountBadgeStyles = {
    bg: "red.100",
    color: "white",
    borderColor: "red.100",
};

export const blackFridayStyles = {
    bg: "black",
    color: "white",
    borderColor: "black",
};

export const cyberMondayStyles = {
    bg: "#3B61A1",
    color: "white",
    borderColor: "#3B61A1",
};

export const eccoClubSaleStyles = {
    bg: eccoClubBadgeGradient,
    color: "white",
    borderColor: "eccoClub.darkBlue",
};
